// Categorizza un segmento sulla base della nota italiana estratta dal libro.
// Le 4 categorie hanno rendering diverso in PiecePreview.

export type SegmentKind = 'outline' | 'dart' | 'fold' | 'reference'

const REF_LINE_KEYWORDS = [
  'linea vita',
  'linea bacino',
  'linea torace',
  'linea petto',
  'linea spalla',
  'linea collo',
  'linea altezza',
  'linea ginocchio',
  'linea cavallo',
  'linea sotto seno',
  'linea fondo',
  'linea di fondo',
  'asse centrale',
]

export function categorizeSegment(notes: string | undefined): SegmentKind {
  const n = (notes ?? '').toLowerCase().trim()
  if (!n) return 'outline'

  // Riprese / dardi (cuciture interne che ripiegano il tessuto)
  if (n.includes('ripresa') || n.includes('dardo') || n.includes('pince')) {
    return 'dart'
  }

  // Linee di piegatura / centro su piega (asse di simmetria del pezzo)
  if (
    n.startsWith('centro davanti') ||
    n.startsWith('centro dietro') ||
    n.includes('linea di piegatura') ||
    n.includes('linea piegatura') ||
    n.includes('retta di piegatura') ||
    n.includes('drittofilo') ||
    n.includes('dritto filo')
  ) {
    return 'fold'
  }

  // Linee di riferimento orizzontali (costruzione, non cucitura)
  for (const k of REF_LINE_KEYWORDS) {
    if (n.startsWith(k) || n.includes(` ${k}`)) return 'reference'
  }

  return 'outline'
}
